import { CardFooterAction as CardFooterBehavior } from '../../extensions/constants/BehaviorTypes';
import { useBehavior } from '../../extensions/hooks/useBehavior';
import { useAssociatedObjectsCardRedesignContext } from '../../context/AssociatedObjectsCardRedesignContext';
import CardFooterAction from './CardFooterAction';
import { jsx as _jsx } from "react/jsx-runtime";
const CardFooter = ({
  toObjectTypeId,
  fromObjectTypeId,
  fromObjectId,
  hasScope,
  isUngated
}) => {
  const {
    associationDefinition,
    total,
    usageTracker
  } = useAssociatedObjectsCardRedesignContext();
  const cardFooterFunction = useBehavior(CardFooterBehavior, toObjectTypeId, hasScope, isUngated);
  const {
    primaryActionConfig
  } = cardFooterFunction({
    associationDefinition,
    fromObjectId,
    fromObjectTypeId,
    hasScope,
    toObjectTypeId,
    total
  });
  if (!primaryActionConfig) {
    return null;
  }
  return /*#__PURE__*/_jsx(CardFooterAction, {
    actionConfig: primaryActionConfig,
    toObjectTypeId: toObjectTypeId,
    usageTracker: usageTracker
  });
};
export default CardFooter;